import { render, staticRenderFns } from "./main-center.vue?vue&type=template&id=3bb5277b&scoped=true&"
import script from "./main-center.vue?vue&type=script&lang=js&"
export * from "./main-center.vue?vue&type=script&lang=js&"
import style0 from "./main-center.vue?vue&type=style&index=0&id=3bb5277b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb5277b",
  null
  
)

export default component.exports